<template>
  <div>
    <el-card :key="repo.id" v-for="repo of repos">
      <h3>
        <router-link
          :to="{ name: 'repo_preview', params: { repo_id: repo.id } }"
        >
          {{ repo.title }} {{ repo.version }} ({{
            repo.created_at | parseTime
          }})
        </router-link>
      </h3>
      <div class="tags">
        <QueryTag
          :key="idx"
          v-for="(tag, idx) of repo.tags"
          type="info"
          :tagName="tag"
        ></QueryTag>
      </div>
    </el-card>
  </div>
</template>

<script>
import { ParseTimeFilterMixin, RouteQueryTagMixin } from "@/mixins";
import QueryTag from "@/components/QueryTag";
export default {
  name: "ReposListPublic",
  props: ["repos"],
  mixins: [ParseTimeFilterMixin, RouteQueryTagMixin],
  components: {
    QueryTag
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles-variables.scss";
/deep/.el-card__body {
  padding: 10px 20px;
}
a {
  font-size: 1.3em;
  text-decoration: none;
  color: $main-blue;
  &:hover {
    color: $sec-blue;
  }
}
.tags {
  margin-top: -10px;
}
</style>
